import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Kr998Service } from "../../services/kr998/kr998.service";
import { Ikr998Data } from "../../interfaces/ert-kr998/ert-kr998Data";
import { FacilityService } from "../../services/administration/facilities/facilities.service";
import { IFacilityData } from "../../interfaces/administration/facilityData";
import { ActivatedRoute, Router } from "@angular/router";
import { TrainingType } from "../../services/administration/trainingtypes/trainingtypes";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { Kr998ErtUsersService } from "../../services/kr998ErtUsers/kr998ErtUsers.service";
import { Ikr998ErtUsers } from "../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { LoggedUserService } from "../../services/common/logged-user.service";
import { start } from "repl";

@Component({
  selector: "app-ert-edit-kr998",
  templateUrl: "./ert-edit-kr998.component.html",
})
export class ErtEditKr998Component implements OnInit {
  krForm: FormGroup;
  id: number;
  data: Ikr998Data;
  kr998ErtUsers: Ikr998ErtUsers[];
  facilities: IFacilityData[];
  formErrors: string[] = [];
  instructors: ERTUser[] = [];
  trainingTypes = TrainingType;
  selectedCrew: IPicklistValuesData;
  selectedCategory: IPicklistValuesData;
  crewFieldId: number = 0;
  categoryFieldId: number = 0;

  facilityId: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private k998Service: Kr998Service,
    private userService: ERTUserService,
    private facilityService: FacilityService,
    private kr998ErtUserService: Kr998ErtUsersService,
    private pickListsService: PicklistService,
    private loggedUserService: LoggedUserService
  ) {
    this.krForm = this.fb.group({
      id: [{ value: "", disabled: true }],
      facilityId: ["", Validators.required],
      company: ["", Validators.required],
      crew: [""],
      instructor: [""],
      category: [""],
      description: [""],
      hours: ["", Validators.required],
      location: ["", Validators.required],
      startDateTime: "",
      endDateTime: "",
      classDate: [""],
      trainingType: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadRecord();
    this.pickListsService.getFieldIdByName("Crew").subscribe((crewFieldId) => {
      if (crewFieldId) {
        this.crewFieldId = crewFieldId;
      }
    });
    this.pickListsService
      .getFieldIdByName("Category")
      .subscribe((categoryFieldId) => {
        if (categoryFieldId) {
          this.categoryFieldId = categoryFieldId;
        }
      });
  }

  loadRecord(): void {
    this.id = +this.route.snapshot.paramMap.get("id")!;
    this.k998Service.getKr998(this.id, this.facilityId).subscribe((data) => {
      this.data = data;
      this.initializeRecord();
    });
    this.facilityService.getFacilities().subscribe((facilities) => {
      this.facilities = facilities;
    });

    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.facilityId = Number(user?.facilityId) || 0;
      this.userService.getUsersAndInstructors(this.facilityId).subscribe((data) => {
        this.instructors = data.instructors.sort((a, b) => {
          return a.fullName
            .toLowerCase()
            .localeCompare(b.fullName.toLowerCase());
        });
      });
    });

    this.kr998ErtUserService.getAllKr998ErtUsers().subscribe((users) => {
      this.kr998ErtUsers = users;
    });
  }

  initializeRecord(): void {
    const selectedCrew = this.getSelectedPicklistField(this.crewFieldId);
    const selectedCategory = this.getSelectedPicklistField(
      this.categoryFieldId
    );
    this.krForm.patchValue({
      id: this.data.id,
      facilityId: this.data.facility.id,
      company: this.data.company,
      crew: selectedCrew ? selectedCrew.id : "",
      instructor: this.data.kr998ErtUsers[0].userErtId,
      category: selectedCategory ? selectedCategory.id : "",
      description: this.data.description,
      hours: this.data.hours,
      location: this.data.location,
      startDateTime: this.data.startDateTime,
      endDateTime: this.data.endDateTime,
      classDate: "",
      trainingType: this.data.trainingType,
    });
  }

  getSelectedPicklistField(fieldId: number) {
    let selectedPicklistValue: IPicklistValuesData =
      this.data?.picklistValues.find((x) => x.picklistFieldId === fieldId);

    return selectedPicklistValue;
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onCategorySelected(category: IPicklistValuesData): void {
    this.selectedCategory = category;
  }

  onSubmit(): void {
    this.formErrors = this.k998Service.validateView(this.krForm);
    if (this.formErrors.length === 0) {
      const updatedData: Ikr998Data = {
        ...this.krForm.getRawValue(),
        id: this.data.id,
        crewId: this.selectedCrew
          ? this.selectedCrew.id
          : this.krForm.get("crew").value,
        categoryId: this.selectedCategory
          ? this.selectedCategory.id
          : this.krForm.get("category").value,
        kr998ErtUsers: [
          {
            kr998DetailsId: this.getKr998DetailsId(
              Number(this.krForm.get("instructor")?.value),
              this.data.id
            ),
            kr998Id: this.data.id,
            userErtId: Number(this.krForm.get("instructor")?.value),
            isInstructior: true,
          },
        ],
        picklistValues: [
          {
            id: this.selectedCrew
              ? this.selectedCrew.id
              : this.krForm.get("crew").value,
            value: this.selectedCrew ? this.selectedCrew.value : undefined,
            picklistFieldId: this.crewFieldId,
            facilityId: 1,
          },
          {
            id: this.selectedCategory
              ? this.selectedCategory.id
              : this.krForm.get("category").value,
            value: this.selectedCategory
              ? this.selectedCategory.value
              : undefined,
            picklistFieldId: this.categoryFieldId,
            facilityId: 1,
          },
        ],
      };
      this.k998Service.editKr998(updatedData, this.facilityId).subscribe(() => {
        this.router.navigate(["/ert-kr998"]);
      });
    }
  }

  getKr998DetailsId(userErtId: number, kr998Id: number): any {
    return this.kr998ErtUsers.find(
      (user) => user.userErtId === userErtId && user.kr998Id === kr998Id
    )?.kr998DetailsId;
  }

  onCancel(): void {
    this.router.navigate(["/ert-kr998"]);
  }

  getTrainingTypeKeys(): string[] {
    return Object.keys(this.trainingTypes).filter(
      (key) => !isNaN(Number(this.trainingTypes[key]))
    );
  }
}
